import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'

import {
  checkCleverMapSubscriptionFromWebapp,
  type CleverMapCheckResult,
} from '@/api/cleverMapSubscription.api'
import { useAppDispatch, useAppSelector } from '@/core/store'
import {
  setHasCleverMapAccess,
  setPayed,
  setPayedTours,
  setSelectedCategories,
  setSelectedTab,
} from '@/core/store/catalog.store'

import { IconAllPins, IconMustSee, IconTop100, IconTours } from '../../Ui/Icons'

const categoriesMap = [
  {
    name: 'allPins',
    // filters now replaced by filter index (see Home.page)
    //    filter: ['10', '7', '5', '3'],
    index: 0,
    icon: <IconAllPins />,
  },
  {
    name: 'top',
    // filters now replaced by index
    // filter: ['10', '7'],
    icon: <IconTop100 />,
    index: 1,
  },
  {
    name: 'mustSee',
    // filters now replaced by filter index (see Home.page)
    // filter: ['!'],
    icon: <IconMustSee />,
    index: 2,
  },
]

export const CategoriesForMap = ({
  isExcursionBeingSelected,
  setExcursionBeingSelected,
}: {
  isExcursionBeingSelected: boolean
  setExcursionBeingSelected: (state: boolean) => void
}) => {
  const { selectedTags, isPayedClient, payedTours, selectedTab } = useAppSelector(
    (store) => store.catalogStore,
  )
  const dispatch = useAppDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation('navigation')

  const handleCategoryChange = (tab: string) => {
    dispatch(setSelectedCategories(selectedTags))
    if (window.location.pathname !== '/') {
      setExcursionBeingSelected(false)
    }

    if (tab !== 'allPins' && tab !== 'mustSee' && tab !== 'top') {
      return window.scrollTo(0, 0)
    }
    dispatch(setSelectedTab({ type: tab }))
    window.scrollTo(0, 0)
  }

  const getCurrentFilter = () => selectedTags

  const [searchParams, setSearchParams] = useSearchParams()

  const applyCleverMapCheckResult = useCallback(
    (result: CleverMapCheckResult) => {
      if (result.needsAuthRedirect) {
        dispatch(setHasCleverMapAccess(false))
        return
      }
      dispatch(setHasCleverMapAccess(result.hasCleverMapAccess))
    },
    [dispatch],
  )

  const postDataSubscription = async (refresh_token, user_id) => {
    console.log('Subscription request')
    console.log(process.env)
    try {
      const response = await fetch(
        `${process.env.REACT_APP_WP_URL}/wp-json/wm-check/v1/user/tours`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // Add other headers if needed (like authorization)
          },
          body: JSON.stringify({
            RefreshToken: refresh_token,
            ID: user_id,
            token: process.env.REACT_APP_WP_TOKEN,
            // AccessToken: access_token,
          }),
        },
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const result = await response.json()
      console.log(result)
      if (result['success'] == '1' && result['active'] == '1') {
        console.log('Set payed subscription')
        dispatch(setPayed(true))
      } else {
        dispatch(setPayed(false))
        if (isTokenExpiredError(result)) {
          clearAuthCookies()
        }
      }
    } catch (err) {
      console.log(err)
      dispatch(setPayed(false))
    }
  }

  const postData = async (refresh_token, user_id) => {
    console.log('Tour access request')
    try {
      const response = await fetch(
        `${process.env.REACT_APP_WP_URL}/wp-json/wm-check/v1/user/tours`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // Add other headers if needed (like authorization)
          },
          body: JSON.stringify({
            RefreshToken: refresh_token,
            ID: user_id,
            token: process.env.REACT_APP_WP_TOKEN,
          }),
        },
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const result = await response.json()
      console.log(result)
      if (result['success'] == '1' || result['result']) {
        console.log('Set payed')
        const tours = Object.keys(JSON.parse(result['result']))
        console.log(JSON.parse(result['result']))
        console.log(tours)
        dispatch(setPayedTours(tours))
        console.log(payedTours)
      } else {
        dispatch(setPayedTours([]))
        if (isTokenExpiredError(result)) {
          clearAuthCookies()
        }
      }
    } catch (err) {
      console.log(err)
      dispatch(setPayedTours([]))
    }
  }

  function getCookie(name) {
    const cookies = document.cookie.split('; ')
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=')
      if (cookieName === name) {
        return decodeURIComponent(cookieValue)
      }
    }
    return null
  }

  function clearAuthCookies() {
    document.cookie = 'WM_RefreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    document.cookie = 'WM_ID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    document.cookie = 'WM_AccessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    console.log('Auth cookies cleared due to expired token')
    window.dispatchEvent(new Event('auth-cookies-cleared'))
  }

  function isTokenExpiredError(result) {
    const message = result?.message || ''
    return (
      message.includes('NotAuthorizedException') ||
      message.includes('Refresh Token has expired') ||
      message.includes('Invalid Refresh Token') ||
      message.includes('SerializationException') ||
      (result?.success == '0' && message.includes('AdminInitiateAuth'))
    )
  }

  useEffect(() => {
    // Set payet if p=475089hfkdjfdjgfliureyg341f7hg4g13
    // console.log(searchParams.get('p'))
    // console.log(searchParams.get('p') == '475089hfkdjfdjgfliureyg341f7hg4g13')
    // if (searchParams.get('p') && searchParams.get('p') == '475089hfkdjfdjgfliureyg341f7hg4g13')
    //   dispatch(setPayed(true))
    const refresh_token = getCookie('WM_RefreshToken')
    const user_id = getCookie('WM_ID')
    // console.log(refresh_token, access_token)
    // if (refresh_token && access_token && !isPayedClient) {
    if (refresh_token && user_id) {
      // console.log(refresh_token)
      postData(refresh_token, user_id)
      postDataSubscription(refresh_token, user_id)
    }

    //If startExcursion in URL OR tour parameter exists then open excursion pop-up
    if (location.search.substring(1) === 'startExcursion' || searchParams.get('tour')) {
      // navigate('/map?startExcursion')
      navigate('/map?tour=' + searchParams.get('tour'))
      setExcursionBeingSelected(true)
    }
  }, [])

  useEffect(() => {
    const refresh_token = getCookie('WM_RefreshToken')
    const user_id = getCookie('WM_ID')
    if (!refresh_token || !user_id) {
      dispatch(setHasCleverMapAccess(false))
      return
    }
    let cancelled = false
    void (async () => {
      const outcome = await checkCleverMapSubscriptionFromWebapp(refresh_token, user_id)
      if (!cancelled) applyCleverMapCheckResult(outcome)
    })()
    return () => {
      cancelled = true
    }
  }, [dispatch, applyCleverMapCheckResult])

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState !== 'visible') return
      const refresh_token = getCookie('WM_RefreshToken')
      const user_id = getCookie('WM_ID')
      if (!refresh_token || !user_id) {
        dispatch(setHasCleverMapAccess(false))
        return
      }
      void (async () => {
        const outcome = await checkCleverMapSubscriptionFromWebapp(refresh_token, user_id)
        applyCleverMapCheckResult(outcome)
      })()
    }
    document.addEventListener('visibilitychange', onVisible)
    return () => document.removeEventListener('visibilitychange', onVisible)
  }, [applyCleverMapCheckResult])

  useEffect(() => {
    const onAuthCleared = () => dispatch(setHasCleverMapAccess(false))
    window.addEventListener('auth-cookies-cleared', onAuthCleared)
    return () => window.removeEventListener('auth-cookies-cleared', onAuthCleared)
  }, [dispatch])

  return (
    <div className="categories">
      <div className="container">
        <div className="categories__carousel">
          <ul className="categories__carousel-list">
            {categoriesMap.map((item, index) => (
              <Link to="/map" key={index} onClick={() => handleCategoryChange(item.name)}>
                <li
                  className={`categories__carousel-item ${
                    selectedTab === item.name &&
                    !isExcursionBeingSelected &&
                    window.location.pathname !== '/'
                      ? 'active'
                      : ''
                  }`}
                >
                  <div className="categories__carousel-locate">{item.icon}</div>
                  <div className="categories__carousel-content">
                    <p>{t(item.name)}</p>
                  </div>
                </li>
              </Link>
            ))}
            {
              <li className="position-relative">
                <Link
                  onClick={() => {
                    if (window.location.pathname !== '/') {
                      setExcursionBeingSelected(true)
                      // modalSettings.open = false
                    } else {
                      window.scrollTo(0, 0)
                    }
                    const refresh_token = getCookie('WM_RefreshToken')
                    const access_token = getCookie('WM_AccessToken')
                    if (refresh_token && access_token) {
                      // console.log(refresh_token)
                      postData(refresh_token, access_token)
                    }
                  }}
                  to={'/map?startExcursion'}
                >
                  <div
                    className={`categories__carousel-item ${
                      isExcursionBeingSelected ? 'active' : ''
                    }`}
                  >
                    <div className="categories__carousel-locate">
                      <IconTours></IconTours>
                    </div>
                    <div className="categories__carousel-content">
                      <p data-test={window.location.href}>TOURS</p>
                    </div>
                  </div>
                </Link>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  )
}
